import type { SoQuyTienMatRequest, SoQuyTienMatRow } from '@/types/schemas';
import QUERY_KEYS from '@/constants/query-keys';
import api from '@/lib/api';

interface SoQuyTienMatResponse<T = SoQuyTienMatRow> {
  results: T[];
  count: number;
  next: string | null;
  previous: string | null;
}

export const fetchAllSoQuyTienMat = async (
  entitySlug: string,
  body: Partial<SoQuyTienMatRequest> = {},
  pageSize = 200
): Promise<SoQuyTienMatRow[]> => {
  let page = 1;
  let all: SoQuyTienMatRow[] = [];
  let totalCount = 0;

  while (true) {
    const response = await api.post<SoQuyTienMatResponse<SoQuyTienMatRow>>(
      `/entities/${entitySlug}/erp/${QUERY_KEYS.SO_QUY_TIEN_MAT}/`,
      body,
      {
        params: {
          page,
          page_size: pageSize
        }
      }
    );

    const pageResults = response.data.results || [];
    totalCount = response.data.count ?? totalCount;
    all = all.concat(pageResults);

    if (!pageResults.length) {
      break;
    }

    const hasNext = response.data.next;

    if (!hasNext && pageResults.length < pageSize) {
      break;
    }

    if (totalCount && all.length >= totalCount) {
      break;
    }

    page += 1;
  }

  return all;
};
